import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

// Email service for order notifications
export const emailService = {
  // Send order processing email
  async sendOrderProcessingEmail(email, orderId, customerName, items, totalAmount) {
    try {
      console.log('📧 Sending order processing email...', { email, orderId, customerName });
      
      const sendEmail = httpsCallable(functions, 'sendOrderProcessingEmail');
      const result = await sendEmail({
        email,
        orderId,
        customerName,
        items,
        totalAmount
      });
      
      console.log('✅ Order processing email sent successfully:', result.data);
      return result.data;
    } catch (error) {
      console.error('❌ Error sending order processing email:', error);
      throw error;
    }
  },

  // Send order shipped email
  async sendOrderShippedEmail(email, orderId, customerName, items, totalAmount, trackingNumber = null) {
    try {
      console.log('📦 Sending order shipped email...', { email, orderId, customerName, trackingNumber });
      
      const sendEmail = httpsCallable(functions, 'sendOrderShippedEmail');
      const result = await sendEmail({
        email,
        orderId,
        customerName,
        items,
        totalAmount,
        trackingNumber
      });
      
      console.log('✅ Order shipped email sent successfully:', result.data);
      return result.data;
    } catch (error) {
      console.error('❌ Error sending order shipped email:', error);
      throw error;
    }
  },

  // Send order delivered email
  async sendOrderDeliveredEmail(email, orderId, customerName, items, totalAmount) {
    try {
      console.log('✅ Sending order delivered email...', { email, orderId, customerName });
      
      const sendEmail = httpsCallable(functions, 'sendOrderDeliveredEmail');
      const result = await sendEmail({
        email,
        orderId,
        customerName,
        items,
        totalAmount
      });
      
      console.log('✅ Order delivered email sent successfully:', result.data);
      return result.data;
    } catch (error) {
      console.error('❌ Error sending order delivered email:', error);
      throw error;
    }
  }
};

export default emailService;
